module.exports = __webpack_public_path__ + "static/media/ro_at_kempton.ed3c53dd.jpg";